var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.enabled
    ? _c(
        "li",
        { staticClass: "news-item" },
        [
          _c("span", { staticClass: "score" }, [
            _vm._v(_vm._s(_vm.item.evpaBIBNo)),
          ]),
          _vm._v(" "),
          _c("table", { staticStyle: { width: "100%" } }, [
            _c("tbody", [
              _c("tr", { staticClass: "heady" }, [
                _c("td", [_vm._v("Status")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.item.mbsdStatus))]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("Full Name")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.item.mbsdFullName))]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("Identity Number")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.item.mbsdIDNumber))]),
              ]),
              _vm._v(" "),
              _c("tr", { staticStyle: { "font-size": "13px" } }, [
                _c("td", [_vm._v("E-mail")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.item.mbsdEmail))]),
              ]),
              _vm._v(" "),
              _c("tr", { staticStyle: { "font-size": "13px" } }, [
                _c("td", [_vm._v("Gender")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(_vm._f("gender")(_vm.item.evpaGender))),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", { staticStyle: { "font-size": "13px" } }, [
                _c("td", [_vm._v("Date of Birth")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.item.mbsdBirthDate))]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: {
              src:
                "https://private.borobudurmarathon.com/view/" +
                _vm.item.mbsdFile,
            },
          }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", { staticClass: "text-center" }, [
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href:
                    "https://private.borobudurmarathon.com/view/" +
                    _vm.item.mbsdFile,
                },
              },
              [_vm._v(_vm._s(_vm.item.mbsdFile))]
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticStyle: {
                padding: ".5em",
                "margin-top": "1em",
                "text-transform": "uppercase",
                "letter-spacing": "2px",
                "font-weight": "800",
              },
              attrs: { block: "", variant: "primary" },
              on: { click: _vm.verifyData },
            },
            [_vm._v("Whitelist")]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/Grid.vue